export default {
  props: {
    showPassword: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      show: true,
      isOn: this.showPassword,
    };
  },
  computed: {
    classModifiers() {
      return {
        'show-password--on': this.isOn,
        'show-password--off': !this.isOn,
      };
    },
    title() {
      return this.isOn ? 'Hide password' : 'Show password';
    },
  },
  methods: {
    onPasswordToggle() {
      this.$emit('showPassword');
      this.show = false;
      this.isOn = !this.isOn;
      setTimeout(() => {
        this.show = true;
      }, 0);
    },
  },
};
